
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SortingDetailsDialog extends _Ext.ItemEditorDialog<SortingDetailsRow> {
        
        protected getFormKey() { return SortingDetailsForm.formKey; }
        //protected getIdProperty() { return SortingDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return SortingDetailsRow.localTextPrefix; }
        //protected getNameProperty() { return SortingDetailsRow.nameProperty; }
        //protected getService() { return SortingDetailsService.baseUrl; }
        protected getDeletePermission() { return SortingDetailsRow.deletePermission; }
        protected getInsertPermission() { return SortingDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SortingDetailsRow.updatePermission; }
    
        public AtbId: number;
        protected form = new SortingDetailsForm(this.idPrefix);
        constructor() {
            super();

            q.hideEditorLabel(this.form.ItemsDetails);
            q.setGridEditorHeight(this.form.ItemsDetails, 300)
            q.hideEditorToolbar(this.form.ItemsDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NewPieces);
            q.setTextRightAlign(this.form.NewWeight);
            this.form.ProductTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.cascadeField = "TypeId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value.toString();
                this.checkAttribute();
            })
            this.form.SubCategoryId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.QualityId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.SieveId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.StoneSizeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.StoneColorId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.NewPieces.changeSelect2(e => {
                var pcs = this.form.Pieces.value;
                var wt = this.form.Weight.value;
                this.form.NewWeight.value = (wt / pcs) * this.form.NewPieces.value;
            })
            var fieldEditor: JQuery = this.form.NewWeight.element.closest(".editor");

            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">Create Lot</button>')
                //.addClass('inplace-button')
                //.addClass('inplace-search btn bg-olive btn-flat margin')
                .addClass('btn bg-olive btn-flat margin')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

        }
        protected inplaceSearchClick(e: any): void {

            if (this.form.NewWeight.value == 0 || this.form.NewWeight.value == undefined || this.form.NewPieces.value == 0 || this.form.NewPieces.value == undefined) {
                Q.alert('New Pieces and Weight value cannot be 0')
                return;
            }
            if (this.form.NewWeight.value > 0) {
                if (this.form.NewPieces.value == 0 || this.form.NewPieces.value == undefined) {
                    Q.alert('New Pieces should be added first');
                    this.form.NewWeight.value = 0;
                    return;
                }
            }

            var baseitemid = this.form.ProductTypeId.value == undefined ? 0 : this.form.ProductTypeId.value;
            var typeid = this.form.CategoryId.value == undefined ? 0 : this.form.CategoryId.value;
            var subtypeid = this.form.SubCategoryId.value == undefined ? 0 : this.form.SubCategoryId.value;
            var qualityid = this.form.QualityId.value == undefined ? 0 : this.form.QualityId.value;
            var sieveid = this.form.SieveId.value == undefined ? 0 : this.form.SieveId.value;
            var StoneSizeId = this.form.StoneSizeId.value == undefined ? 0 : this.form.StoneSizeId.value;
            var stonecolorid = this.form.StoneColorId.value == undefined ? 0 : this.form.StoneColorId.value;

            if (baseitemid == "" || typeid == "" || subtypeid == ""
                || qualityid == "" || isNaN(sieveid) || StoneSizeId == "" || stonecolorid == "") {
                Q.alert('All Attributes need to be selected');
                this.form.NewPieces.value = 0;
                return;
            }

            this.entity.ProductTypeId = parseInt(baseitemid.toString());
            this.entity.CategoryId = parseInt(typeid.toString());
            this.entity.SubCategoryId = parseInt(subtypeid.toString());
            this.entity.SieveId = parseInt(sieveid.toString());
            this.entity.StoneSizeId = parseInt(StoneSizeId.toString());
            this.entity.StoneColorId = parseInt(stonecolorid.toString());
            this.entity.QualityId = parseInt(qualityid.toString());
            var lotno = (this.parentEditor.parentDialog as SortingDialog).form.LotNo.value;
            if (this.form.ItemsDetails.getItems().length > 0) {
                var Items = [];
                var newitems = this.form.ItemsDetails.getItems();

                
                var newpcs = 0; var newwt = 0;
                for (var i = 0; i < newitems.length; i++) {
                    newpcs += newitems[i].Pieces;
                    newwt += newitems[i].Weight;
                }
                var pcs = this.form.Pieces.value-newpcs;
                var wt = this.form.Weight.value-newwt;
                if (pcs >= this.form.NewPieces.value && wt >= this.form.NewWeight.value)
                    this.form.ItemsDetails.setData(this.entity, this.AtbId, this.form.NewPieces.value,
                        this.form.NewWeight.value, parseInt(this.form.NewProductId.value),lotno);
                
                else
                    Q.notifyError('Invalid Value(New Pieces/New Weight) should be less than Pieces/Weight');
               

            } else {
                if (this.form.NewPieces.value <= this.form.Pieces.value && this.form.NewWeight.value <= this.form.Weight.value)
                    this.form.ItemsDetails.setData(this.entity, this.AtbId, this.form.NewPieces.value,
                        this.form.NewWeight.value, parseInt(this.form.NewProductId.value), lotno);
                else
                    Q.notifyError('Invalid Value(New Pieces/New Weight) should be less than Pieces/Weight');
            }
            this.form.NewPieces.element.focus;
            this.form.CategoryId.items.filter(x => x.id = this.form.CategoryId.value)[0].text;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.AttributeId.value != "") {
                var oldsubtypeid = this.form.SubCategoryId.value.toString();
                this.form.SubCategoryId.cascadeField = "TypeId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value.toString();
                this.form.SubCategoryId.value = oldsubtypeid;
                this.AtbId = parseInt(this.form.AttributeId.value);
            }
            this.form.NewProductId.value = this.form.ProductId.value.toString();
        }
        checkAttribute() {
            var baseitemid = parseInt(this.form.ProductTypeId.value) == undefined ? 0 : parseInt(this.form.ProductTypeId.value);
            var typeid = parseInt(this.form.CategoryId.value) == undefined ? 0 : parseInt(this.form.CategoryId.value);
            var subtypeid = parseInt(this.form.SubCategoryId.value) == undefined ? 0 : parseInt( this.form.SubCategoryId.value);
            var qualityid = parseInt(this.form.QualityId.value) == undefined ? 0 : parseInt( this.form.QualityId.value);
            var sieveid = (this.form.SieveId.value) == undefined ? 0 : (this.form.SieveId.value);
            var StoneSizeId = parseInt(this.form.StoneSizeId.value) == undefined ? 0 : parseInt(this.form.StoneSizeId.value);
            var stonecolorid = parseInt(this.form.StoneColorId.value) == undefined ? 0 : parseInt(this.form.StoneColorId.value);

            var attributeid;
            OMS.CommonAttributesService.GetProductATB({

                ProductTypeId: baseitemid,
                CategoryId: typeid,
                SubCategoryId: subtypeid,
                QualityId: qualityid,
                SieveId: sieveid,
                StoneSizeId: StoneSizeId,
                StoneColorId: stonecolorid
            }, response => {
                attributeid = response.AttributeId
            }, { async: false }
            ); 
            if (attributeid.length > 0) {
                this.AtbId = attributeid[0].AttributeId;
            }
            else {
                this.AtbId= 0;
            }

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.ItemsDetails.getItems();
            var totalweight = this.form.Weight.value;
            var totalpieces = this.form.Pieces.value;
            var newweight = 0;
            var newpieces = 0;
            for (var i = 0; i < items.length; i++) {
                newweight += items[i].Weight;
                newpieces += items[i].Pieces;
            }
            if (totalweight < newweight) {
                Q.alert('Total Weights do not match');
                return false;
            } else if (totalweight == newweight && totalpieces > newpieces) {
                Q.alert('All weight canot be consumed');
                return false;
            } else
                return true;
        }
    }
}